module.exports = __webpack_public_path__ + "img/bili.cd7cd640.svg";